import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

export interface ConfirmUnsavedChangesModalProps {
  isOpen: boolean;
  saveChanges: () => void;
  discard: () => void;
  cancel: () => void;
}

export const ConfirmUnsavedChangesModal: React.FC<
  ConfirmUnsavedChangesModalProps
> = ({ isOpen, saveChanges, discard, cancel }) => (
  <Modal
    isOpen={isOpen}
    onClose={cancel}
    title="Save changes"
    modalClassName="w-full md:w-[670px]"
    centerContent={true}
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large" fontWeight="normal">
        You have applied some changes in this page. Do you want to save them?
      </Typography>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={discard}
          className="w-[220px]"
        >
          Continue without saving
        </Button>
        <Button color="neutral" onClick={saveChanges} className="w-[200px]">
          Save
        </Button>
      </div>
    </div>
  </Modal>
);
